import { render, staticRenderFns } from "./sortUp.vue?vue&type=template&id=58275e84&"
import script from "./sortUp.vue?vue&type=script&lang=js&"
export * from "./sortUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports